import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ContactModal, UnauthenticatedSalesModal } from '@phishtool/products';
import { useStaticState } from '@phishtool/ui';
import FAQ from '~components/faq';
import Hero from '~components/hero';
import { HeroButton } from '~components/hero/hero-button';
import HowDoesPhishToolWork from '~components/how-does-phishtool-work';
import Pricing from '~components/pricing';
import SocialProof from '~components/social-proof';
import WhyPhishTool from '~components/why-phishtool';
import { unauthenticatedUserService, contentService } from '~service';
const Home = () => {
    const [staticData] = useStaticState();
    const { data } = contentService.useGetHomepageContent({});
    if (!data) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Hero, Object.assign({}, data.hero, { children: [_jsx(HeroButton, { to: `${staticData === null || staticData === void 0 ? void 0 : staticData.env.APP_HOST}/`, children: "Start Investigating" }), _jsx(HeroButton, { to: "#pricing", children: "Compare Plans" })] })), _jsx(SocialProof, Object.assign({}, data.socialProof)), _jsx(WhyPhishTool, Object.assign({}, data.whyPhishTool)), _jsx(HowDoesPhishToolWork, Object.assign({}, data.howDoesPhishToolWork)), _jsx(Pricing, Object.assign({}, data.pricing)), _jsx(FAQ, Object.assign({}, data.faq)), _jsx(ContactModal, { useSendContactRequest: unauthenticatedUserService.useSendContactRequest }), _jsx(UnauthenticatedSalesModal, { source: "web-homepage", useContactSalesTeam: unauthenticatedUserService.useContactSalesTeam })] }));
};
export default Home;
